module.exports = __webpack_public_path__ + "static/media/001 color panel.ce03a35c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/redbox/001 color panel.png
// module id = 593
// module chunks = 0